import { createRegisteredPlanarRenderPaths } from '../../helpers/renderBackendRegistry.js';
import { DefaultRenderPathResolver } from '../DefaultRenderPathResolver.js';
import { CpuImageSlicePath } from './CpuImageSliceRenderPath.js';
import { CpuVolumeSlicePath } from './CpuVolumeSliceRenderPath.js';
import { VtkImageMapperPath } from './VtkImageMapperRenderPath.js';
import { VtkVolumeSlicePath } from './VtkVolumeSliceRenderPath.js';
export function createDefaultPlanarRenderPaths() {
    return [
        new CpuImageSlicePath(),
        new CpuVolumeSlicePath(),
        new VtkImageMapperPath(),
        new VtkVolumeSlicePath(),
        ...createRegisteredPlanarRenderPaths(),
    ];
}
export function createPlanarRenderPathResolver(paths = createDefaultPlanarRenderPaths()) {
    return new DefaultRenderPathResolver(paths);
}
